<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <v-card-text class="pa-4">
        <div class="modal-body">
          <div class="mb-3">
            こちらの内容でMicrosoft Peering向けNATを設定します。よろしいですか？
          </div>

          <!-- VPN/VNNコード -->
          <v-row>
            <v-col cols="12">
              <app-label-group
                label="VPN/VNコード"
                :value="currentInfo.vpnVnCode"
              />
            </v-col>
          </v-row>

          <!-- NAPT用グローバルIP -->
          <v-row>
            <v-col cols="12">
              <app-label-group label="NAT用グローバルIP">
                <template #value>
                  <div class="ml-3">
                    現在 {{ currentInfo.usedNat }}個 / 上限
                    {{ currentInfo.upperLimitNat }}個<br />
                    追加グローバルIP数 {{ newIp.length }} 個
                  </div>
                </template>
              </app-label-group>
            </v-col>
          </v-row>

          <!-- NAT用グローバルIP、プライベートIP一覧 -->
          <v-table density="compact" class="border-less">
            <thead class="text-caption">
              <tr>
                <th class="th_globalIpAddress font-weight-bold">
                  グローバルIP
                </th>
                <th class="th_privateIpAddress font-weight-bold">
                  プライベートIP
                </th>
                <th class="th_description font-weight-bold">備考</th>
              </tr>
            </thead>
            <tbody>
              <!-- 払出済みグローバルIP情報 -->
              <tr v-for="(item, i) in natSetting" :key="i + 'paid'">
                <td>{{ item.globalIpAddress }}</td>
                <td>{{ item.privateIpAddress }}</td>
                <td class="text-pre-wrap">{{ item.description || "-" }}</td>
              </tr>

              <!-- 払い出していないグローバルIP情報 -->
              <tr v-for="(item, i) in newIp" :key="i + 'new'">
                <td>設定完了後にIPが払い出されます</td>
                <td>{{ item.privateIpAddress }}</td>
                <td class="text-pre-wrap">{{ item.description || "-" }}</td>
              </tr>
            </tbody>
          </v-table>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="modal-footer">
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { NatNaptDetailEntity, NatIpEntity } from "@/apis/MSPeeringIpApi";

export default defineComponent({
  name: "MSNatSettingModifyConfirm",
  props: {
    /** NAT設定情報 */
    currentInfo: {
      type: Object as PropType<NatNaptDetailEntity>,
      required: true,
    },
    /** 払出済みのNAT設定情報 */
    natSetting: {
      type: Array as PropType<NatIpEntity[]>,
      required: true,
    },
    /** 払出していないNAT設定情報 */
    newIp: {
      type: Array as PropType<NatIpEntity[]>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.th_globalIpAddress {
  max-width: 200px;
}
.th_privateIpAddress {
  max-width: 140px;
}
.th_description {
  max-width: 300px;
}
th {
  font-size: 1rem;
}
</style>
